import { DeliveryOption } from '@/types/DeliveryOptions';
import {
  DeliveryOptionCalc,
  DeliveryProviderV2,
  DeliveryTariffV2,
  IDeliveryCalculateResponseDataV2
} from '@/types/IDeliveryCalculateResponse';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface DeliveryCalculationState {
  loading: boolean;
  availableProviders: DeliveryProviderV2[];
  availableDeliveryTypes: string[];
  tariffs: DeliveryTariffV2[];
  currentCityData: IDeliveryCalculateResponseDataV2 | null;
  dataLoaded: boolean;
  availableProvidersOld: DeliveryOption[];
  filteredDeliveryOptions: DeliveryOptionCalc[];
}

const initialState: DeliveryCalculationState = {
  loading: false,
  availableProviders: [],
  availableDeliveryTypes: [],
  tariffs: [],
  currentCityData: null,
  dataLoaded: false,
  availableProvidersOld: [],
  filteredDeliveryOptions: []
};

const deliveryCalculation = createSlice({
  name: 'deliveryCalculation',
  initialState,
  reducers: {
    setDeliveryCalculationState: (
      state,
      action: PayloadAction<Partial<DeliveryCalculationState>>
    ) => {
      Object.assign(state, action.payload);
    },
    resetDeliveryCalculationState: () => initialState
  }
});

export const { setDeliveryCalculationState, resetDeliveryCalculationState } =
  deliveryCalculation.actions;

export default deliveryCalculation.reducer;
